var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
const initialState = { userLanguage: 'en-US' };
const UserContext = React.createContext(initialState);
const CHANGE_LANGUAGE = gql `
  mutation LogUser($language: String!) {
    changePreferences(language: $language) {
      success
    }
  }
`;
export const CronoUserProvider = ({ setUserLanguage, userLanguage, userID, userData, children, refetchLoggedUser, loadingLoggedUser, userQueryName }) => {
    const { i18n } = useTranslation();
    const onMutationCompleted = () => {
        if (process.env.REACT_APP_URI_ENV !== 'prod') {
            console.log('changed user language');
        }
        refetchLoggedUser().then(data => setUserLanguage(data.data.loggedUser.preferences.language));
    };
    const onMutationError = (data) => {
        console.error('error with change language mutation ' + data);
    };
    const [logUser] = useMutation(CHANGE_LANGUAGE, {
        onCompleted: onMutationCompleted,
        onError: onMutationError
    });
    useEffect(() => {
        if (userLanguage) {
            i18n.changeLanguage(userLanguage.substring(0, 2));
        }
    }, [i18n, userLanguage]);
    const setLanguage = (lang) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield logUser({
                variables: {
                    language: lang
                }
            });
            setUserLanguage(lang);
            i18n.changeLanguage(lang.substring(0, 2));
        }
        catch (e) {
            console.error('error on change language function: ' + e);
        }
    });
    return (_jsx(UserContext.Provider, Object.assign({ value: {
            setLanguage,
            userLanguage,
            userID,
            userData,
            refetchLoggedUser,
            loadingLoggedUser,
            userQueryName
        } }, { children: children })));
};
export const useCronoUser = () => useContext(UserContext);
